import React from 'react';

interface ToolIconProps {
  size?: number;
  className?: string;
  color?: string;
}

export const PowerPlantIcon: React.FC<ToolIconProps> = ({ 
  size = 18, 
  className = '', 
  color = '#6b7280' 
}) => (
<svg width={size} height={size} viewBox="0 0 26 26" fill={color} xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_4005_2129"  maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
<path d="M0 0H26V26H0V0Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.9999 11H14.9449L16.9189 6.394C16.9841 6.24191 17.0105 6.07601 16.9958 5.91118C16.9811 5.74635 16.9258 5.58775 16.8347 5.44959C16.7436 5.31143 16.6197 5.19804 16.474 5.11957C16.3283 5.0411 16.1654 5.00002 15.9999 5H10.9999C10.8041 4.99983 10.6125 5.05716 10.4489 5.16489C10.2854 5.27262 10.1571 5.426 10.0799 5.606L7.0799 12.606C7.01466 12.7582 6.98824 12.9242 7.00298 13.0891C7.01773 13.254 7.07319 13.4126 7.16439 13.5508C7.25559 13.689 7.37967 13.8024 7.52549 13.8808C7.67132 13.9592 7.83433 14.0001 7.9999 14H9.7339L7.0719 20.627C6.6719 21.622 7.9069 22.463 8.6859 21.727L13.7099 16.985L18.6499 12.76C19.3559 12.156 18.9289 11 17.9999 11ZM12.5099 11.606C12.4447 11.758 12.4183 11.9238 12.4329 12.0886C12.4476 12.2533 12.5029 12.4119 12.5938 12.55C12.6848 12.6881 12.8086 12.8015 12.9542 12.8801C13.0997 12.9586 13.2625 12.9998 13.4279 13H15.2919L12.3719 15.498L10.6239 17.148L12.1409 13.373C12.2019 13.2213 12.2247 13.057 12.2075 12.8944C12.1902 12.7318 12.1333 12.5759 12.0419 12.4404C11.9504 12.3049 11.8271 12.1939 11.6827 12.1171C11.5384 12.0404 11.3774 12.0001 11.2139 12H9.5169L11.6589 7H14.4829L12.5099 11.606Z" fill="black"/>
</mask>
<g mask="url(#mask0_4005_2129)">
<path d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z" fill={color as string}/>
</g>
</svg>
);

export const PoleIcon: React.FC<ToolIconProps> = ({ 
  size = 16, 
  className = '', 
  color = '#6b7280' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 35 37" 
    className={className}
    fill="none"
  >
    <path
      d="M17.5 2V35M2 6.95H33M3.55 3.65V6.95M9.75 3.65V6.95M25.25 3.65V6.95M31.45 3.65V6.95M28.35 6.95L17.5 18.5L6.65 6.95"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MeterIcon: React.FC<ToolIconProps> = ({ 
  size = 16, 
  className = '', 
  color = '#6b7280' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 18 21" 
    className={className}
    fill={'#6b7280'}
    style={{ transform: 'translate(3px, 1.5px)' }}
  >
    <path d="M6 19.9502V18.4502C4.23333 17.8335 2.79167 16.7545 1.675 15.2132C0.558334 13.6719 0 11.9175 0 9.9502C0 8.7002 0.237667 7.52953 0.713 6.4382C1.18833 5.34686 1.82967 4.39686 2.637 3.5882C3.44433 2.77953 4.39433 2.13786 5.487 1.6632C6.57967 1.18853 7.74233 0.950863 8.975 0.950197C10.2077 0.94953 11.3743 1.1872 12.475 1.6632C13.5757 2.1392 14.534 2.78086 15.35 3.5882C16.166 4.39553 16.812 5.34553 17.288 6.4382C17.764 7.53086 18.0013 8.70153 18 9.9502C18 11.9169 17.4377 13.6629 16.313 15.1882C15.1883 16.7135 13.7507 17.7925 12 18.4252V19.9502C12 20.2335 11.904 20.4712 11.712 20.6632C11.52 20.8552 11.2827 20.9509 11 20.9502C10.7173 20.9495 10.48 20.8539 10.288 20.6632C10.096 20.4725 10 20.2349 10 19.9502V18.9002C9.83333 18.9335 9.66667 18.9502 9.5 18.9502H8.975C8.80833 18.9502 8.64567 18.9462 8.487 18.9382C8.32833 18.9302 8.166 18.9175 8 18.9002V19.9502C8 20.2335 7.904 20.4712 7.712 20.6632C7.52 20.8552 7.28267 20.9509 7 20.9502C6.71733 20.9495 6.48 20.8539 6.288 20.6632C6.096 20.4725 6 20.2349 6 19.9502ZM6 8.0002H12C12.2833 8.0002 12.521 7.90453 12.713 7.7132C12.905 7.52186 13.0007 7.2842 13 7.0002C12.9993 6.7162 12.9033 6.47886 12.712 6.2882C12.5207 6.09753 12.2833 6.00153 12 6.0002H6C5.71667 6.0002 5.47933 6.0962 5.288 6.2882C5.09667 6.4802 5.00067 6.71753 5 7.0002C4.99933 7.28286 5.09533 7.52053 5.288 7.7132C5.48067 7.90586 5.718 8.00153 6 8.0002ZM8 13.2502L7.5 13.7502C7.28333 13.9669 7.175 14.2169 7.175 14.5002C7.175 14.7835 7.28333 15.0335 7.5 15.2502C7.71667 15.4669 7.96667 15.5752 8.25 15.5752C8.53333 15.5752 8.78333 15.4669 9 15.2502L10.55 13.7002C10.75 13.5002 10.85 13.2669 10.85 13.0002C10.85 12.7335 10.75 12.5002 10.55 12.3002L10 11.7502L10.5 11.2502C10.7167 11.0335 10.825 10.7835 10.825 10.5002C10.825 10.2169 10.7167 9.96686 10.5 9.7502C10.2833 9.53353 10.0333 9.4252 9.75 9.4252C9.46667 9.4252 9.21667 9.53353 9 9.7502L7.45 11.3002C7.25 11.5002 7.15 11.7335 7.15 12.0002C7.15 12.2669 7.25 12.5002 7.45 12.7002L8 13.2502Z" fill={color}/>
  </svg>
);

export const TransformerIcon: React.FC<ToolIconProps> = ({ 
  size = 16, 
  className = '', 
  color = '#6b7280' 
}) => (
<svg     width={size} 
    height={size} fill={color} className="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M672 128a32 32 0 0 1 32 32l-0.032 64H800a32 32 0 0 1 32 32v96h32a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32h-32l1.504 96.224a32 32 0 0 1-31.52 32.48h-0.832L768 832.352a31.68 31.68 0 0 0-32 31.296V864a32 32 0 0 1-32 32h-64a32 32 0 0 1-32-32 31.808 31.808 0 0 0-31.808-31.808H576l-128.544 0.704a31.648 31.648 0 0 0-31.456 31.648c0 17.376-14.08 31.456-31.456 31.456H320a32 32 0 0 1-32-32 32 32 0 0 0-32-32H224a32 32 0 0 1-32-32v-96H160a32 32 0 0 1-32-32v-288a32 32 0 0 1 32-32h32V256a32 32 0 0 1 32-32h96V160a32 32 0 0 1 64 0v64h96V160a32 32 0 0 1 64 0v64h95.968L640 160a32 32 0 0 1 32-32z m-320 256a32 32 0 0 0-31.776 28.256L320 416v256a32 32 0 0 0 63.776 3.744L384 672v-256a32 32 0 0 0-32-32z m160 0a32 32 0 0 0-31.776 28.256L480 416v256a32 32 0 0 0 63.776 3.744L544 672v-256a32 32 0 0 0-32-32z m160 0a32 32 0 0 0-31.776 28.256L640 416v256a32 32 0 0 0 63.776 3.744L704 672v-256a32 32 0 0 0-32-32z"  /></svg>
);
